// Add your JS customizations here
jQuery(document).ready(function($) { 

	$(window).on('scroll', function() {

		if ($(this).scrollTop() > 100) {
    		$('.navbar').addClass('scrolled');
    		$('#chat').addClass('scrolled');
    		//$('#enquire').addClass('scrolled');
    	} else {
    		$('.navbar').removeClass('scrolled');
    		$('#chat').removeClass('scrolled');
    		//$('#enquire').removeClass('scrolled');
    	}

	});

	$(window).load(function() {

		if ($(this).scrollTop() > 100) {
    		$('.navbar').addClass('scrolled');
    		$('#chat').addClass('scrolled');
    		//$('#enquire').addClass('scrolled');
    	} else {
    		$('.navbar').removeClass('scrolled');
    		$('#chat').removeClass('scrolled');
    		//$('#enquire').removeClass('scrolled');
    	}

	});

	if ($('.page-template-home').length > 0) {

		$('#header_carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		    var i = (currentSlide ? currentSlide : 0) + 1;
		    var slidesToShow = slick.slickGetOption('slidesToShow');
		    var curPage = parseInt((i-1)/slidesToShow) + 1;
		    var lastPage =  parseInt((slick.slideCount-1)/slidesToShow) + 1;
		    $('.slideCount').html(curPage);
		    $('.slideTotal').html(lastPage);
		});

		

		$('#header_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			dots: false,
			fade: true,
			prevArrow: $('.slide_prev'),
			nextArrow: $('.slide_next'),
		});

		var $bottom_banner_height = $('#header_bottom').outerHeight(true);

		$('#header_corner').css('bottom',$bottom_banner_height);

		$(window).on('resize', function () {
			var $bottom_banner_height_resize = $('#header_bottom').outerHeight(true);

			$('#header_corner').css('bottom',$bottom_banner_height_resize);
		});
		

	};

	if ($('.page-template-why').length > 0) {
		var $bottom_banner_height = $('#header_bottom').outerHeight(true);

		$('#header_corner').css('bottom',$bottom_banner_height);

		$(window).on('resize', function () {
			var $bottom_banner_height_resize = $('#header_bottom').outerHeight(true);

			$('#header_corner').css('bottom',$bottom_banner_height_resize);
		});
	};

	

	if ($(window).width() > 992) {

		$('#spotlight_carousel').on('init', function(event, slick, direction){
  			var $slideHeight = $('.slick-current .card').outerHeight(true);
  			var $slideHeightHalf = $slideHeight / 2;
  			$('#spotlight_bg').height($slideHeightHalf);
		});

	};

	$('#spotlight_carousel').slick({
		slidesToShow: 2.75,
		slidesToScroll: 1,
		autoplay: false,
		arrows: true,
		dots: false,
		prevArrow: $('#spotlight_prev'),
		nextArrow: $('#spotlight_next'),
		infinite: false,
	});

	$('#patient_feedback_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: true,
		dots: false,
		prevArrow: $('#test_prev'),
		nextArrow: $('#test_next'),
		infinite: true,
	});

	$('.hamburger').click(function() {
		$('.sub_menu').removeClass('active');
		$('#primary_other_menu .nav-link').removeClass('inactive');
		$('#primary_menu .nav-link').removeClass('inactive');
		$('#primary_menu .nav-link').removeClass('active');
		$('#primary_other_menu .nav-link').removeClass('active');
		$('#main-nav').removeClass('sub_open');
		$('body').toggleClass('modal-open');
		$(this).toggleClass('is-active');
		$('#botonics_menu').toggleClass('active').scrollTop(0);
		$('#main-nav').toggleClass('menu_open');
		$('.navbar_contact').toggleClass('menu_open');
		$('.navbar_toggler').toggleClass('menu_open');
		$('.search_toggler').toggleClass('menu_open');
		$('.phone_toggler').toggleClass('menu_open');
		$('#chat').toggleClass('menu_open');
		$('.collapse').collapse('hide');
	});

	$('#primary_other_menu .hasSub .nav-link').click(function(event) {
		event.preventDefault();
		//$('#primary_menu .nav-link').removeClass('active').removeClass('inactive');
		var target = $(this).attr('href');
		$(target).scrollTop(0);
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$('#primary_menu .nav-link').removeClass('inactive');
			$('#primary_other_menu .nav-link').removeClass('inactive');
			$(target).removeClass('active');
			$('#main-nav').removeClass('sub_open');
		}
		else if($(this).hasClass('inactive')) {
			$('#primary_menu .hasSub .nav-link.active').removeClass('active').addClass('inactive');
			$('#primary_other_menu .hasSub .nav-link.active').removeClass('active').addClass('inactive');
			$(this).removeClass('inactive');
			$(this).addClass('active');
			$('.sub_menu').removeClass('active');
			$(target).addClass('active');
		}
		else {
			$(this).addClass('active');
			$('#primary_menu .nav-link').not(this).addClass('inactive');
			$('#primary_other_menu .nav-link').not(this).addClass('inactive');
			$(target).addClass('active');
			$('#main-nav').addClass('sub_open');
		}
	});

	$('#primary_menu .hasSub .nav-link').click(function(event) {
		event.preventDefault();
		//$('#primary_menu .nav-link').removeClass('active').removeClass('inactive');
		var target = $(this).attr('href');
		$(target).scrollTop(0);
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$('#primary_menu .nav-link').removeClass('inactive');
			$(target).removeClass('active');
			$('#main-nav').removeClass('sub_open');
		}
		else if($(this).hasClass('inactive')) {
			$('#primary_menu .hasSub .nav-link.active').removeClass('active').addClass('inactive');
			$(this).removeClass('inactive');
			$(this).addClass('active');
			$('.sub_menu').removeClass('active');
			$(target).addClass('active');
		}
		else {
			$(this).addClass('active');
			$('#primary_menu .nav-link').not(this).addClass('inactive');
			$(target).addClass('active');
			$('#main-nav').addClass('sub_open');
		}
	});

	$('.sub_trigger_parent').click(function(event) {
		event.preventDefault();
		var target = $(this).attr('href');
		$('.collapse').not(target).collapse('hide');
	});

	$('.sub_trigger_child').click(function(event) {
		event.preventDefault();
		var sub_target = $(this).attr('href');
		$('.sub_collapse').not(sub_target).collapse('hide');
	});

	$('#spotlight_trigger').click(function(event) {
		event.preventDefault();
		var menu_item = '#menu-item-1985 .nav-link';
		$('.sub_menu').removeClass('active');
		$('#primary_menu .nav-link').removeClass('inactive');
		$('#primary_menu .nav-link').removeClass('active');
		$('#main-nav').removeClass('sub_open');
		$('body').addClass('modal-open');
		$('.hamburger').addClass('is-active');
		$('#botonics_menu').addClass('active').scrollTop(0);
		$('#main-nav').addClass('menu_open');
		$('.navbar_contact').addClass('menu_open');
		$('.navbar_toggler').addClass('menu_open');
		$('.search_toggler').addClass('menu_open');
		$('.phone_toggler').addClass('menu_open');
		$('#chat').addClass('menu_open');
		$(menu_item).addClass('active');
		$('#primary_menu .nav-link').not(menu_item).addClass('inactive');
		$('#plastic_surgery').addClass('active');
	});

	$('#spotlight_trigger_xs').click(function(event) {
		event.preventDefault();
		var menu_item = '#ps_xs_trigger';
		$('.sub_menu').removeClass('active');
		$('#main-nav').removeClass('sub_open');
		$('body').addClass('modal-open');
		$('.hamburger').addClass('is-active');
		$('#botonics_menu').addClass('active').scrollTop(0);
		$('#main-nav').addClass('menu_open');
		$('.navbar_contact').addClass('menu_open');
		$('.navbar_toggler').addClass('menu_open');
		$('.search_toggler').addClass('menu_open');
		$('.phone_toggler').addClass('menu_open');
		$('#chat').addClass('menu_open');
		$(menu_item).attr('aria-expanded',true);
		$('#plastic_surgery_xs').collapse('show');
	});

	$('#results_trigger').click(function(event) {
		event.preventDefault();
		var menu_item = '#menu-item-1987 .nav-link';
		$('.sub_menu').removeClass('active');
		$('#primary_menu .nav-link').removeClass('inactive');
		$('#primary_menu .nav-link').removeClass('active');
		$('#main-nav').removeClass('sub_open');
		$('body').addClass('modal-open');
		$('.hamburger').addClass('is-active');
		$('#botonics_menu').addClass('active').scrollTop(0);
		$('#main-nav').addClass('menu_open');
		$('.navbar_contact').addClass('menu_open');
		$('.navbar_toggler').addClass('menu_open');
		$('.search_toggler').addClass('menu_open');
		$('.phone_toggler').addClass('menu_open');
		$('#chat').addClass('menu_open');
		$(menu_item).addClass('active');
		$('#primary_menu .nav-link').not(menu_item).addClass('inactive');
		$('#before_after').addClass('active');
	});

	$('#results_trigger_xs').click(function(event) {
		event.preventDefault();
		var menu_item = '#ba_xs_trigger';
		$('.sub_menu').removeClass('active');
		$('#main-nav').removeClass('sub_open');
		$('body').addClass('modal-open');
		$('.hamburger').addClass('is-active');
		$('#botonics_menu').addClass('active').scrollTop(350);
		$('#main-nav').addClass('menu_open');
		$('.navbar_contact').addClass('menu_open');
		$('.navbar_toggler').addClass('menu_open');
		$('.search_toggler').addClass('menu_open');
		$('.phone_toggler').addClass('menu_open');
		$('#chat').addClass('menu_open');
		$(menu_item).attr('aria-expanded',true);
		$('#before_after_xs').collapse('show');
	});


	$('#wrapper_footer .menu-item-1944 .nav-link').click(function(event) {
		event.preventDefault();
		$('#main-nav').addClass('menu_open');
		$('.navbar_contact').addClass('menu_open');
		$('.navbar_toggler').addClass('menu_open');
		$('.search_toggler').addClass('menu_open');
		$('.phone_toggler').addClass('menu_open');
		$('#chat').addClass('menu_open');
		$('.sub_menu').removeClass('active');
		$('body').addClass('modal-open');
		$('#botonics_menu').addClass('active').scrollTop(0);
		$('.hamburger').addClass('is-active');
		$('#main-nav').removeClass('sub_open');
		if ($(window).width() > 992) {
			var menu_item = '#menu-item-1985 .nav-link';
			$('#primary_menu .nav-link').removeClass('inactive');
			$('#primary_menu .nav-link').removeClass('active');	
			$(menu_item).addClass('active');
			$('#primary_menu .nav-link').not(menu_item).addClass('inactive');
			$('#plastic_surgery').addClass('active');
		}
		if ($(window).width() < 992) {
			var menu_item = '#ps_xs_trigger';
			$(menu_item).attr('aria-expanded',true);
			$('#plastic_surgery_xs').collapse('show');
		}
	});

	$('#wrapper_footer .menu-item-1945 .nav-link').click(function(event) {
		event.preventDefault();
		$('#main-nav').addClass('menu_open');
		$('.navbar_contact').addClass('menu_open');
		$('.navbar_toggler').addClass('menu_open');
		$('.search_toggler').addClass('menu_open');
		$('.phone_toggler').addClass('menu_open');
		$('#chat').addClass('menu_open');
		$('.sub_menu').removeClass('active');
		$('body').addClass('modal-open');
		$('#botonics_menu').addClass('active').scrollTop(0);
		$('.hamburger').addClass('is-active');
		$('#main-nav').removeClass('sub_open');
		if ($(window).width() > 992) {
			var menu_item = '#menu-item-1986 .nav-link';
			$('#primary_menu .nav-link').removeClass('inactive');
			$('#primary_menu .nav-link').removeClass('active');	
			$(menu_item).addClass('active');
			$('#primary_menu .nav-link').not(menu_item).addClass('inactive');
			$('#cosmetic_dermatology').addClass('active');
		}
		if ($(window).width() < 992) {
			var menu_item = '#cd_xs_trigger';
			$(menu_item).attr('aria-expanded',true);
			$('#cosmetic_dermatology_xs').collapse('show');
		}
	});

	$('#wrapper_footer .menu-item-1946 .nav-link').click(function(event) {
		event.preventDefault();
		$('#main-nav').addClass('menu_open');
		$('.navbar_contact').addClass('menu_open');
		$('.navbar_toggler').addClass('menu_open');
		$('.search_toggler').addClass('menu_open');
		$('.phone_toggler').addClass('menu_open');
		$('#chat').addClass('menu_open');
		$('.sub_menu').removeClass('active');
		$('body').addClass('modal-open');
		$('#botonics_menu').addClass('active').scrollTop(0);
		$('.hamburger').addClass('is-active');
		$('#main-nav').removeClass('sub_open');
		if ($(window).width() > 992) {
			var menu_item = '#menu-item-1987 .nav-link';
			$('#primary_menu .nav-link').removeClass('inactive');
			$('#primary_menu .nav-link').removeClass('active');	
			$(menu_item).addClass('active');
			$('#primary_menu .nav-link').not(menu_item).addClass('inactive');
			$('#before_after').addClass('active');
		}
		if ($(window).width() < 992) {
			var menu_item = '#ba_xs_trigger';
			$(menu_item).attr('aria-expanded',true);
			$('#before_after_xs').collapse('show');
		}
	});

	$('#wrapper_footer .menu-item-1947 .nav-link').click(function(event) {
		event.preventDefault();
		$('#main-nav').addClass('menu_open');
		$('.navbar_contact').addClass('menu_open');
		$('.navbar_toggler').addClass('menu_open');
		$('.search_toggler').addClass('menu_open');
		$('.phone_toggler').addClass('menu_open');
		$('#chat').addClass('menu_open');
		$('.sub_menu').removeClass('active');
		$('body').addClass('modal-open');
		$('#botonics_menu').addClass('active').scrollTop(0);
		$('.hamburger').addClass('is-active');
		$('#main-nav').removeClass('sub_open');
		if ($(window).width() > 992) {
			var menu_item = '#menu-item-1990 .nav-link';
			$('#primary_menu .nav-link').removeClass('inactive');
			$('#primary_menu .nav-link').removeClass('active');	
			$(menu_item).addClass('active');
			$('#primary_menu .nav-link').not(menu_item).addClass('inactive');
			$('#conditions').addClass('active');
		}
		if ($(window).width() < 992) {
			var menu_item = '#ba_xs_trigger';
			$(menu_item).attr('aria-expanded',true);
			$('#conditions_xs').collapse('show');
		}
	});

	$('#wrapper_footer .menu-item-1950 .nav-link').click(function(event) {
		event.preventDefault();
		$('#main-nav').addClass('menu_open');
		$('.navbar_contact').addClass('menu_open');
		$('.navbar_toggler').addClass('menu_open');
		$('.search_toggler').addClass('menu_open');
		$('.phone_toggler').addClass('menu_open');
		$('#chat').addClass('menu_open');
		$('.sub_menu').removeClass('active');
		$('body').addClass('modal-open');
		$('#botonics_menu').addClass('active').scrollTop(0);
		$('.hamburger').addClass('is-active');
		$('#main-nav').removeClass('sub_open');
		if ($(window).width() > 992) {
			var menu_item = '#menu-item-1950 .nav-link';
			$('#primary_menu .nav-link').removeClass('inactive');
			$('#primary_other_menu .nav-link').removeClass('inactive');
			$('#primary_other_menu .nav-link').removeClass('active');	
			$('#primary_menu .nav-link').removeClass('active');	
			$(menu_item).addClass('active');
			$('#primary_menu .nav-link').not(menu_item).addClass('inactive');
			$('#primary_other_menu .nav-link').not(menu_item).addClass('inactive');
			$('#about').addClass('active');
		}
		if ($(window).width() < 992) {
			var menu_item = '#about_xs_trigger';
			$(menu_item).attr('aria-expanded',true);
			$('#about_xs').collapse('show');
		}
	});

	$('#wrapper_footer .menu-item-1951 .nav-link').click(function(event) {
		event.preventDefault();
		$('#main-nav').addClass('menu_open');
		$('.navbar_contact').addClass('menu_open');
		$('.navbar_toggler').addClass('menu_open');
		$('.search_toggler').addClass('menu_open');
		$('.phone_toggler').addClass('menu_open');
		$('#chat').addClass('menu_open');
		$('.sub_menu').removeClass('active');
		$('body').addClass('modal-open');
		$('#botonics_menu').addClass('active').scrollTop(0);
		$('.hamburger').addClass('is-active');
		$('#main-nav').removeClass('sub_open');
		if ($(window).width() > 992) {
			var menu_item = '#menu-item-1950 .nav-link';
			$('#primary_menu .nav-link').removeClass('inactive');
			$('#primary_other_menu .nav-link').removeClass('inactive');
			$('#primary_other_menu .nav-link').removeClass('active');	
			$('#primary_menu .nav-link').removeClass('active');	
			$(menu_item).addClass('active');
			$('#primary_menu .nav-link').not(menu_item).addClass('inactive');
			$('#primary_other_menu .nav-link').not(menu_item).addClass('inactive');
			$('#locations').addClass('active');
		}
		if ($(window).width() < 992) {
			var menu_item = '#locations_xs_trigger';
			$(menu_item).attr('aria-expanded',true);
			$('#locations_xs').collapse('show');
		}
	});

	if ($('#book_today_bg').length > 0) {
		var bookTodayTop = $('#book_today').offset().top;
		var bookTodayHeight = $('#book_today').outerHeight(true);
		var bookScroll = bookTodayTop - bookTodayHeight;

		$(window).on('resize', function () {
			var bookTodayTop = $('#book_today').offset().top;
			var bookTodayHeight = $('#book_today').outerHeight(true);
			var bookScroll = bookTodayTop - bookTodayHeight;
		});

		var $bookHeight = $('#book_today').outerHeight(true);
		var $bookHeightHalf = $bookHeight / 2;
		$('#book_today_bg').height($bookHeightHalf);

	};

	if ($('.single-client').length > 0) {
		$('.gallery_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			dots: false,
			fade: true,
			prevArrow: $('.gallery_prev'),
			nextArrow: $('.gallery_next'),
			//adaptiveHeight: true,
			asNavFor: $('.gallery_thumbs'),
		});
		$('.gallery_thumbs').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false,
			dots: false,
			fade: false,
			adaptiveHeight: true,
			asNavFor: $('.gallery_carousel'),
			focusOnSelect: true,
		});

		$('.related_stories').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			dots: false,
			fade: false,
			prevArrow: $('.related_prev'),
			nextArrow: $('.related_next'),
			responsive: [
			    {
			      	breakpoint: 769,
			     	settings: {
			        	slidesToShow: 2,
			        	slidesToScroll: 1,
			      	}
			    },
			    {
			      breakpoint: 480,
			      settings: {
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			      	}
			    }
			]
		});
	};

	if ($('.single-locations').length > 0) {
		var navHeight = $('#main-nav').outerHeight(true);		
		var treatment_navTop = $('#location_nav').offset().top;
		var treatment_navHeight = $('#location_nav').outerHeight(true);
		var treatment_navCombined = treatment_navTop + treatment_navHeight;
		console.log(treatment_navCombined);
		$(window).on('resize', function () {
			var navHeight = $('#main-nav').outerHeight(true);			
			var treatment_navTop = $('#location_nav').offset().top;
			var treatment_navHeight = $('#location_nav').outerHeight(true);
			$.fn.matchHeight._update();
		});

		if ($(window).width() > 992) {
			$(window).on('scroll', function() {
				var scroll = $(window).scrollTop();
				if (scroll >= (treatment_navCombined)){
					var navScrolledHeight = $('#main-nav.scrolled').outerHeight(true);
					$('#location_nav').addClass('fixed').css('top',navScrolledHeight).removeClass('pt_24');;
					$('#location_nav .pretitle').removeClass('d-lg-block');
					$('#treatment_content').css('margin-top',treatment_navHeight);
				} else {
					$('#location_nav').removeClass('fixed').css('top','').addClass('pt_24');
					$('#location_nav .pretitle').addClass('d-lg-block');
					$('#treatment_content').css('margin-top',0);
				}

				var top_of_element = $("#spotlight").offset().top;
		    	var bottom_of_element = $("#spotlight").offset().top + $("#spotlight").outerHeight();
		    	var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
		    	
		    	if ((bottom_of_screen > top_of_element) && (scroll < bottom_of_element)){
		        	$('#location_nav').removeClass('fixed').css('top','').addClass('pt_24');
		        	$('#location_nav .pretitle').addClass('d-lg-block');
		        	$('#treatment_content').css('margin-top',0);
			   	} else {
				   	
				}
			});
		}
	};

	if ($('.single-team_member').length > 0) {

		var navHeight = $('#main-nav').outerHeight(true);		
		var treatment_navTop = $('#specialist_nav').offset().top;
		var treatment_navHeight = $('#specialist_nav').outerHeight(true);
		var treatment_navCombined = treatment_navTop + treatment_navHeight;
		console.log(treatment_navCombined);
		$(window).on('resize', function () {
			var navHeight = $('#main-nav').outerHeight(true);			
			var treatment_navTop = $('#specialist_nav').offset().top;
			var treatment_navHeight = $('#specialist_nav').outerHeight(true);
		});

		if ($(window).width() > 992) {
			$(window).on('scroll', function() {
				var scroll = $(window).scrollTop();
				if (scroll >= (treatment_navCombined)){
					var navScrolledHeight = $('#main-nav.scrolled').outerHeight(true);
					$('#specialist_nav').addClass('fixed').css('top',navScrolledHeight).removeClass('pt_24');;
					$('#specialist_nav .pretitle').removeClass('d-lg-block');
					$('#treatment_content').css('margin-top',treatment_navHeight);
				} else {
					$('#specialist_nav').removeClass('fixed').css('top','').addClass('pt_24');
					$('#specialist_nav .pretitle').addClass('d-lg-block');
					$('#treatment_content').css('margin-top',0);
				}

				var top_of_element = $("#cta_row").offset().top;
		    	var bottom_of_element = $("#cta_row").offset().top + $("#cta_row").outerHeight();
		    	var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
		    	
		    	if ((bottom_of_screen > top_of_element) && (scroll < bottom_of_element)){
		        	$('#specialist_nav').removeClass('fixed').css('top','').addClass('pt_24');
		        	$('#specialist_nav .pretitle').addClass('d-lg-block');
		        	$('#treatment_content').css('margin-top',0);
			   	} else {
				   	
				}
			});
		}

		$('.team_carousel').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			dots: false,
			fade: false,
			prevArrow: $('.team_prev'),
			nextArrow: $('.team_next'),
			responsive: [
			    {
			      	breakpoint: 993,
			     	settings: {
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			      	}
			    },
			]
		});

		$('.ba_modal').on('shown.bs.modal', function (e) {
			$('.ba_carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: false,
				dots: false,
				fade: true,
				adaptiveHeight: true,
			});
			$('.ba_carousel').addClass('show');
		});

		$('.ba_modal').on('hidden.bs.modal', function (e) {
			$('.ba_carousel').slick('unslick');
			$('.ba_carousel').removeClass('show');
		});

		$('.ba_modal_prev').click(function(e) {
			var target = $(this).data('slider');
			e.preventDefault();
	      	$(target).slick('slickPrev');
	   	});

	   	$('.ba_modal_next').click(function(e) {
	   		var target = $(this).data('slider');
	   		e.preventDefault();
	      	$(target).slick('slickNext');
	  	});

		$('.load_more').click(function(event) {
			event.preventDefault();
			var target = $(this).data('target');
			$(target).toggleClass('show');
			$(this).text($(this).text() == 'Show more' ? 'Show less' : 'Show more');
		});

		$('.qa_more').click(function(event) {
			event.preventDefault();
			$('.qa_row_hide').toggleClass('show');
			$(this).text($(this).text() == 'Read more' ? 'Read less' : 'Read more');
		});
	};

	if ($('.page-template-contact').length > 0) {
		$('#input_5_3').select2({
			minimumResultsForSearch: Infinity,
    		allowClear: false,
    		width: '100%',
    		placeholder: 'Select',
		});
		$('#input_5_8_6').select2({
			minimumResultsForSearch: Infinity,
    		allowClear: false,
    		width: '100%',
		});
		$('#input_5_12').select2({
			minimumResultsForSearch: Infinity,
    		allowClear: false,
    		width: '100%',
    		placeholder: 'Select',
		});
		$('#input_5_13').select2({
			minimumResultsForSearch: Infinity,
    		allowClear: false,
    		width: '100%',
    		placeholder: 'Select',
		});
	};

	if ($('.page-template-ppc_landing').length > 0) {
		$('#quick_book_xs_form #input_2_6').select2({
			minimumResultsForSearch: Infinity,
    		allowClear: false,
    		width: '100%',
    		placeholder: 'Treatment of Interest',
		});
		$('#quick_book_form #input_2_6').select2({
			minimumResultsForSearch: Infinity,
    		allowClear: false,
    		width: '100%',
    		placeholder: 'Treatment of Interest',
		});

		$('#before_after_carousel').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			dots: false,
			fade: false,
			adaptiveHeight: false,
			prevArrow: $('.ba_prev'),
			nextArrow: $('.ba_next'),
			responsive: [
			    {
			      	breakpoint: 769,
			     	settings: {
			        	slidesToShow: 2,
			        	slidesToScroll: 1,
			      	}
			    },
			    {
			      breakpoint: 480,
			      settings: {
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			      	}
			    }
			]
		});

		$('.ba_modal').on('shown.bs.modal', function (e) {
			$('.ba_carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: false,
				dots: false,
				fade: true,
				adaptiveHeight: true,
			});
			$('.ba_carousel').addClass('show');
		});

		$('.ba_modal').on('hidden.bs.modal', function (e) {
			$('.ba_carousel').slick('unslick');
			$('.ba_carousel').removeClass('show');
		});

		$('.ba_modal_prev').click(function(e) {
			var target = $(this).data('slider');
			e.preventDefault();
	      	$(target).slick('slickPrev');
	   	});

	   	$('.ba_modal_next').click(function(e) {
	   		var target = $(this).data('slider');
	   		e.preventDefault();
	      	$(target).slick('slickNext');
	  	});
	};

	if ($('.single-treatment').length > 0) {
		if ($(window).width() > 992) {
			$('#treatment_content h1').matchHeight({
				target: $('#sidebar_trustpilot'),
			});
		};

		$(window).on('scroll', function() {

			if ($(this).scrollTop() > 100) {
	    		var navScrolledHeight = $('#main-nav.scrolled').outerHeight(true);
	    	}
		});		

		$(window).load(function() {

			if ($(this).scrollTop() > 100) {
	    		var navScrolledHeight = $('#main-nav.scrolled').outerHeight(true);
	    	}
		});

		$('#input_2_6').select2({
			minimumResultsForSearch: Infinity,
    		allowClear: false,
    		width: '100%',
    		placeholder: 'Treatment of Interest',
		});

		$('#input_3_6').select2({
			minimumResultsForSearch: Infinity,
    		allowClear: false,
    		width: '100%',
    		placeholder: 'Treatment of Interest',
		});

		$('#input_4_6').select2({
			minimumResultsForSearch: Infinity,
    		allowClear: false,
    		width: '100%',
    		placeholder: 'Treatment of Interest',
		});

		var navHeight = $('#main-nav').outerHeight(true);
		var specialists = $('#sidebar_specialists').offset().top;
		var specialistsHeight = $('#sidebar_specialists').outerHeight(true);
		var specialistsCombined = specialists + specialistsHeight - navHeight;
		
		var treatment_navTop = $('#treatment_nav').offset().top;
		var treatment_navHeight = $('#treatment_nav').outerHeight(true);
		var treatment_navCombined = treatment_navTop + treatment_navHeight;
		$(window).on('resize', function () {
			var navHeight = $('#main-nav').outerHeight(true);
			var specialists = $('#sidebar_specialists').offset().top;
			var specialistsHeight = $('#sidebar_specialists').outerHeight(true);
			var specialistsCombined = specialists + specialistsHeight - navHeight;
			
			var treatment_navTop = $('#treatment_nav').offset().top;
			var treatment_navHeight = $('#treatment_nav').outerHeight(true);
		});

		$(window).on('scroll', function() {

			if ($(this).scrollTop() > 100) {
	    		$('#treatment_quicklinks').addClass('scrolled');
	    	} else {
	    		$('#treatment_quicklinks').removeClass('scrolled');
	    	}

		});		

		$(window).load(function() {

			if ($(this).scrollTop() > 100) {
	    		$('#treatment_quicklinks').addClass('scrolled');
	    	} else {
	    		$('#treatment_quicklinks').removeClass('scrolled');
	    	}

		});

		$('#quicklink_summary').click(function() {
			$(this).toggleClass('open');
			$('#quicklink_contact').removeClass('open');
			$('.modal-content').scrollTop(0);
		});

		$('#quicklink_contact').click(function() {
			$(this).toggleClass('open');
			$('#quicklink_summary').removeClass('open');
			$('.modal-content').scrollTop(0);
		});
		
		$(window).on('scroll', function() {
			var scroll = $(window).scrollTop();

			if (scroll >= (specialistsCombined)){ 
				$('#fixed_contact').addClass('scrolled').css('top','16rem');
			} else {
				$('#fixed_contact').removeClass('scrolled').css('top','-100%');
			}

			if ($('.reviews_template').length > 0) {
			
				var reviewBookTop = $('#book_today').offset().top;
				if (scroll >= (reviewBookTop)){ 
					$('#fixed_contact').addClass('fade');
				} else {
					$('#fixed_contact').removeClass('fade');
				}

			} else {
				if (scroll >= (bookScroll)){ 
					$('#fixed_contact').addClass('fade');
				} else {
					$('#fixed_contact').removeClass('fade');
				}
			}
			
			if ($(window).width() > 992) {
				if (scroll >= (treatment_navCombined)){
					var navScrolledHeight = $('#main-nav.scrolled').outerHeight(true);
					$('#treatment_nav').addClass('fixed').css('top',navScrolledHeight).removeClass('pt_24');;
					$('#treatment_nav .pretitle').removeClass('d-lg-block');
					$('#treatment_content').css('margin-top',treatment_navHeight);
				} else {
					$('#treatment_nav').removeClass('fixed').css('top','').addClass('pt_24');
					$('#treatment_nav .pretitle').addClass('d-lg-block');
					$('#treatment_content').css('margin-top',0);
				}
			}
		});

		window.almComplete = function(alm){
			$('#fixed_contact').removeClass('fade');
		};

		$('.ba_modal').on('shown.bs.modal', function (e) {
			$('.ba_carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: false,
				dots: false,
				fade: true,
				adaptiveHeight: true,
			});
			$('.ba_carousel').addClass('show');
		});

		$('.ba_modal').on('hidden.bs.modal', function (e) {
			$('.ba_carousel').slick('unslick');
			$('.ba_carousel').removeClass('show');
		});

		$('.ba_modal_prev').click(function(e) {
			var target = $(this).data('slider');
			e.preventDefault();
	      	$(target).slick('slickPrev');
	   	});

	   	$('.ba_modal_next').click(function(e) {
	   		var target = $(this).data('slider');
	   		e.preventDefault();
	      	$(target).slick('slickNext');
	  	});

		$('.load_more').click(function(event) {
			event.preventDefault();
			var target = $(this).data('target');
			$(target).toggleClass('show');
			$(this).text($(this).text() == 'Show more' ? 'Show less' : 'Show more');
		});

		$('.qa_more').click(function(event) {
			event.preventDefault();
			$('.qa_row_hide').toggleClass('show');
			$(this).text($(this).text() == 'Read more' ? 'Read less' : 'Read more');
		});
		
	};

	$(document).on('click', '.review_more', function(event) {
		event.preventDefault();
		console.log('text');
		var target = $(this).data('target');
		$(target).toggleClass('show');
		$(this).text($(this).text() == 'Show more' ? 'Show less' : 'Show more');
	});


	$('.reason_more').click(function(event) {
		event.preventDefault();
		$('.reason_fade').toggleClass('show');
		$('.reason_hide').toggleClass('show');
		$(this).text($(this).text() == 'Show more' ? 'Show less' : 'Show more');
	});

	$('.trans_more').click(function(event) {
		event.preventDefault();
		$('.transcript_fade').toggleClass('show');
		$('.transcript_hide').toggleClass('show');
		$('.more_container').hide();
	});

	$('.question_more').click(function(event) {
		event.preventDefault();
		$('.question_fade').toggleClass('show');
		$('.question_hide').toggleClass('show');
		$(this).text($(this).text() == 'Show more' ? 'Show less' : 'Show more');
	});

	$('.launch_video').click(function() {
		var src = $(this).data('src');
		var type = $(this).data('type');
		$('#video_modal iframe').attr('src',src);
		$('#video_modal iframe').addClass(type);
	});

	$('#video_modal').on('hidden.bs.modal', function (e) {
		$('#video_modal .ratio iframe').attr('src','');
		$('#video_modal .ratio iframe').removeClass('.vimeo').removeClass('youtube');
	});

	$('#filter select[name="cat"').select2({
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
		placeholder: 'Category',
	});

	$('#filter select[name="archive-dropdown"').select2({
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
		placeholder: 'Archive',
	});

});